export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey.length === 2 && splitKey[0].length === 1:
      return splitKey[1]

    case splitKey.length === 2:
      return betKey

    case splitKey.length === 3 && splitKey[1] === 'ZODIAC':
    case splitKey.length === 3 && splitKey[1] === 'TAIL' && splitKey[2].length === 1:
      return `${splitKey[1]}:${splitKey[2]}`

    case splitKey.length === 3 && splitKey[0] === 'ALL':
      return `${splitKey[2]}`

    case splitKey.length === 3 && splitKey[1] === 'TAIL' && splitKey[2].length !== 1:
      return splitKey[0] === 'SP' ? betKey : `${splitKey[1]}:${splitKey[2]}`

    case splitKey.length === 3 && splitKey[0] === 'SP':
      return (splitKey[1] === 'OVER' || splitKey[1] === 'UNDER') ? betKey : `${splitKey[1]}:${splitKey[2]}`

    case splitKey.length === 3 && splitKey[1] === 'LOCATE':
    case splitKey.length === 3 && splitKey[1] === 'MATCH':
      return splitKey[0]

    case splitKey.length === 4 && splitKey[0] === 'SP':
      return splitKey[1] === 'DIGIT' ? `${splitKey[0]}:${splitKey[2]}:${splitKey[3]}` : `${splitKey[1]}:${splitKey[2]}:${splitKey[3]}`

    case splitKey.length === 4 && splitKey[1] === 'DIGIT':
      return `${splitKey[2]}:${splitKey[3]}`

    case splitKey.length === 4 && splitKey[2] === 'ZODIAC':
      return splitKey[3].length === 1 ? `${splitKey[2]}:${splitKey[3]}` : `${splitKey[0]}:${splitKey[2]}:${splitKey[3]}`
  }
}
